/**
 * Detalle de conversación abierta (`/app/conversations/:id`), no el listado.
 * El sidebar usa esta ruta para auto-contraerse en escritorio y maximizar el chat.
 */
const CONVERSATION_DETAIL_PATTERN = /^\/app\/conversations\/[^/]+$/

/** Indica si la ruta corresponde al detalle (no al listado) de una conversación. */
export function isConversationDetailPath(pathname: string): boolean {
  return CONVERSATION_DETAIL_PATTERN.test(pathname)
}
